/* eslint-disable no-underscore-dangle */
/* eslint-disable prefer-const */
/* eslint-disable no-trailing-spaces */
/* eslint-disable @angular-eslint/use-lifecycle-interface */
import { Component, OnInit, OnDestroy, ChangeDetectorRef, NgZone } from '@angular/core';
import { BehaviorSubject, Observable, Subscription, forkJoin, from, of, throwError } from 'rxjs';
import { Client } from './models/client.model';
import { ApiService } from './services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { User } from './models/user.model';
import { Module } from 'src/app/models/module.model';
import { catchError, finalize, first, map, switchMap, take, tap } from 'rxjs/operators';
import { AppService } from './app.service';
import { PersistedValueEnum } from './models/persisted-value-enum';
import { trigger, state, style, transition, animate } from '@angular/animations';

type MenuItem = {
  title: string;
  url: string;
  iconName: string;
  moduleId: string;
  children?: MenuItem[];
};

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  animations: [
    trigger('submenuAnimation', [
      state('closed', style({ height: '0px', opacity: 0, overflow: 'hidden' })),
      state('open', style({ height: '*', opacity: 1, overflow: 'hidden' })),
      transition('closed <=> open', [animate('300ms ease-in-out')]),
    ]),
  ],
})
export class AppComponent implements OnInit, OnDestroy {
  loadPage: boolean = false;
  authSub: Subscription;
  clientSub: Subscription;
  isUserLoggedIn: boolean = false;

  currentUser: User | undefined;
  modules: Module[] | undefined;
  menuItems$ = new BehaviorSubject<MenuItem[]>([]);

  intervalId: any;
  showTimerPopUp: boolean = false;
  activeMenuIndex: number | null = null;

  // password expiry countdown
  showTimer: boolean = false;
  countdownSeconds: number; // Total countdown time in seconds
  hours: number;
  minutes: number;
  seconds: number;
  userObj: any;
  private subscription: Subscription;
  constructor(
    public apiService: ApiService,
    private router: Router,
    private ngZone: NgZone,
    private appService: AppService,
    private cdr: ChangeDetectorRef,
  ) {
    this.isUserLoggedIn = false;

    if (localStorage.getItem('user')) {
      let parsed: any = JSON.parse(localStorage.getItem('user'));
      let expDate: string = parsed?.pwd_exp_at ? parsed?.pwd_exp_at : '';
      if (expDate) {
        const expDateObj = new Date(expDate);
        const now = new Date();
        const dateDiff = expDateObj.getTime() - now.getTime();
        const days = Math.floor(dateDiff / (3600 * 24 * 1000));

        if (days == 0) {
          const dateDiffSeconds = Math.floor(dateDiff / 1000);
          this.countdownSeconds = dateDiffSeconds; // Example: 1 hour
          this.showTimer = true;
        } else if (dateDiff <= 0) {
          localStorage.removeItem('user');
          localStorage.setItem('userFullName', '');
          localStorage.setItem('userName', '');
          localStorage.setItem('0', '');
          localStorage.removeItem('token');
          // localStorage.removeItem("refresh");
          localStorage.removeItem('last_activity');
          sessionStorage.clear();
          window.location.href = '/#/auth';
        }
      }
    }
  }

  ngOnDestroy(): void {
    if (this.clientSub !== null && this.clientSub !== undefined) {
      this.clientSub.unsubscribe();
    }
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
    if (this.isLoggedIn() && localStorage.getItem('refresh') && localStorage.getItem('last_activity')) {
      this.startChecking();
    }
  }

  startChecking(): void {
    let last_activity = localStorage.getItem('last_activity') ? parseInt(localStorage.getItem('last_activity')) : null;
    if (last_activity) {
      // Define the threshold in milliseconds
      // const fourteenMinutesAndThirtySecondsInMillis = (14 * 60 * 1000) + (30 * 1000);
      // const fifteenmilliseconds = (15 * 60 * 1000);
      const WARNING_BEFORE = 30 * 1000; // 30 seconds

      this.intervalId = setInterval(() => {
        const expiryTime = last_activity * 1000; // 🔥 convert seconds → milliseconds
        const currentTime = Date.now();

        const remainingTime = expiryTime - currentTime;

        //   // Get the current timestamp
        //   const currentTimestamp = Date.now();

        //   // Calculate the difference
        //   const differenceInMillis = currentTimestamp - last_activity;

        // Check if the difference is greater than or equal to 14 minutes and 30 seconds
        // if (differenceInMillis >= fourteenMinutesAndThirtySecondsInMillis && differenceInMillis < fifteenmilliseconds) {
        //   this.showTimerPopUp = true
        // }
        // if (differenceInMillis >= fifteenmilliseconds) {
        // ✅ 1️⃣ Show popup 30 seconds before expiry
        if (remainingTime <= WARNING_BEFORE && remainingTime > 0) {
          console.log('if runs');
          this.showTimerPopUp = true;
        }

        // ✅ 2️⃣ If expired → logout
        else if (remainingTime <= 0) {
          console.log('else runs');
          this.showTimerPopUp = false;
          localStorage.removeItem('user');
          localStorage.setItem('userFullName', '');
          localStorage.setItem('userName', '');
          localStorage.setItem('0', '');
          localStorage.removeItem('token');
          localStorage.removeItem('refresh');
          localStorage.removeItem('last_activity');
          localStorage.removeItem('subSelectedTab');
          localStorage.removeItem('activeMenuIndex');
          localStorage.removeItem('assetsActiveTab');
          sessionStorage.clear();
          this.appService?.triggerRemoveMenu();
          clearInterval(this.intervalId);
          window.location.href = '/#/auth';
        }
      }, 1000); // 1000 milliseconds = 1 second
    } else {
      this.appService?.triggerStartSessionTimer();
    }
  }

  goTo(pageUrl: string) {
    this.router.navigate(['/' + pageUrl]);
  }

  async extendSession(): Promise<void> {
    try {
      await this.apiService.updateAccesToken();
      this.showTimerPopUp = false;
      clearInterval(this.intervalId);
      this.appService.triggerStartSessionTimer();
    } catch (err) {}
  }

  ngOnInit() {
    // 1. Load menu if already logged in (refresh case)
    this.userObj = JSON.parse(JSON.stringify(localStorage.getItem(PersistedValueEnum.user)) || 'null');
    if (this.isLoggedIn() && this.userObj) {
      this.loadMenuItem();
    } else if (this.userObj === 'null') {
      this.loadMenuItem();
    }

    // 2. Listen for login after app start
    this.apiService.triggerLogin$.subscribe(() => {
      this.userObj = JSON.parse(localStorage.getItem(PersistedValueEnum.user) || 'null');

      if (this.isLoggedIn() && this.userObj) {
        this.loadMenuItem();
      }
    });

    // 3. (Keep your other existing subscriptions)
    this.subscription = this.appService.triggerLogout$.subscribe(() => {
      this.menuItems$.next([]);
    });

    this.subscription = this.appService.triggerSessionTimer$.subscribe(() => {
      this.startChecking();
    });

    this.apiService.showMenu$.subscribe((status) => {
      if (status) {
        this.loadMenuItem();
      }
    });

    this.updateTime();
    setInterval(() => {
      this.updateTime();
    }, 1000);

    this.restoreMenuState();
  }

  loadMenuItem(): void {
    const subdomainObservable = this.getSubdomain();
    const currentUserObservable = this.apiService.user.pipe(
      first(),
      switchMap((user: User) => {
        this.currentUser = user;
        if (this.currentUser && this.isLoggedIn()) {
          this.isUserLoggedIn = true;
          return this.getMenuItems();
        }
        return of<null>(null);
      }),
      tap((menuItems) => {
        if (menuItems) this.menuItems$.next(menuItems);
      }),
    );
    this.cdr.detectChanges();
    (forkJoin([subdomainObservable, currentUserObservable])
      .pipe(
        tap(() => {
          this.loadPage = true;
        }),
      )
      .subscribe({
        error(e) {
          console.log(e);
          this.loadPage = true;
          if (e?.error?.error === 'Expired token' || e?.error?.error === 'Invalid signature') {
            localStorage.removeItem('user');
            localStorage.setItem('userFullName', '');
            localStorage.setItem('userName', '');
            localStorage.setItem('0', '');
            localStorage.removeItem('token');
            // localStorage.removeItem("refresh");
            localStorage.removeItem('last_activity');
            localStorage.removeItem('subSelectedTab');
            localStorage.removeItem('assetsActiveTab');
            localStorage.removeItem('activeMenuIndex');
            sessionStorage.clear();
            this.appService?.triggerRemoveMenu();
            window.location.href = '/#/auth';
          }
          console.error('Error starting the app', e);
        },
      }),
      (err: any) => {
        console.log(err);
        this.loadPage = true;
        if (err?.error?.error === 'Expired token' || err?.error?.error === 'Invalid signature') {
          localStorage.removeItem('user');
          localStorage.setItem('userFullName', '');
          localStorage.setItem('userName', '');
          localStorage.setItem('0', '');
          localStorage.removeItem('token');
          // localStorage.removeItem("refresh");
          localStorage.removeItem('last_activity');
          localStorage.removeItem('subSelectedTab');
          localStorage.removeItem('assetsActiveTab');
          localStorage.removeItem('activeMenuIndex');
          sessionStorage.clear();
          this.appService?.triggerRemoveMenu();
          window.location.href = '/#/auth';
        }
        this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null);
      });

    this.updateTime();
    setInterval(() => {
      this.updateTime();
    }, 1000); // Update every second
  }

  isMenuDisabled$ = this.menuItems$.pipe(map((items) => !items || items.length === 0));

  updateTime() {
    if (this.countdownSeconds > 0) {
      const hours = Math.floor(this.countdownSeconds / 3600);
      const minutes = Math.floor((this.countdownSeconds % 3600) / 60);
      const seconds = this.countdownSeconds % 60;

      this.hours = hours;
      this.minutes = minutes;
      this.seconds = seconds;

      this.countdownSeconds--; // Decrement countdown timer
      localStorage.setItem('expiry_time', this.countdownSeconds.toString());
    } else {
      this.hours = 0;
      this.minutes = 0;
      this.seconds = 0;
    }
  }

  public getSubdomain(): Observable<void> {
    //console.log('checking for subdomain');
    let subdomain = '';
    const domain = window.location.hostname;
    if (domain.indexOf('.') < 0 || domain.split('.')[0] === 'localhost' || domain.split('.')[0] === 'lvh') {
      subdomain = 'demo';
    } else {
      subdomain = domain.split('.plane-ops.com')[0];
    }

    return this.apiService.getClient(subdomain).pipe(
      map((res: Client | string) => {
        if (res != null) {
          try {
            const tempClient = res[0] as Client;
            this.apiService.subDomain.next(tempClient.subdomain);
            this.apiService.client.next(tempClient);
          } catch {
            // console.log(res);
          }
        }
      }),
      catchError((error) => {
        this.loadPage = true;
        if (error?.error?.error === 'Expired token' || error?.error?.error === 'Invalid signature') {
          localStorage.removeItem('user');
          localStorage.setItem('userFullName', '');
          localStorage.setItem('userName', '');
          localStorage.setItem('0', '');
          localStorage.removeItem('token');
          // localStorage.removeItem("refresh");
          localStorage.removeItem('last_activity');
          localStorage.removeItem('subSelectedTab');
          localStorage.removeItem('assetsActiveTab');
          localStorage.removeItem('activeMenuIndex');
          sessionStorage.clear();
          this.appService?.triggerRemoveMenu();
          window.location.href = '/#/auth';
        }
        console.error('Error getting subdomain', error);
        return throwError(error);
      }),
    );
  }

  isLoggedIn(): boolean {
    const response = localStorage.getItem('token') || undefined;
    if (response) {
      return true;
    } else {
      this.loadPage = true;
      return false;
    }
  }

  getMenuItems(): Observable<MenuItem[]> {
    const userData = {
      roleId: this.currentUser.roleId,
      clientID: this.currentUser.clientID,
    };
    const modulePages = ['home', 'settings'];
    const getModulesRequests = modulePages.map((page) => this.apiService.getModules({ ...userData, page }));

    return forkJoin(getModulesRequests).pipe(
      map((responses) => {
        const modules = responses.reduce((acc, modules) => [...acc, ...modules], []);

        let menuItems = modules
          .filter((m) => m.parentPage === 'home')
          .map((m) => ({
            title: m.moduleName,
            url: m.url,
            iconName: this.getModuleIcon(m),
            moduleId: this.parseModuleId(m.moduleId),
            children: modules
              .filter((m2) => m2.parentPage === moduleNameToPageNameMap.get(m.moduleName))
              .map((m2) => ({
                title: m2.moduleName,
                url: m2.url,
                iconName: this.getModuleIcon(m2),
                moduleId: this.parseModuleId(m2.moduleId),
              })),
          }));

        // Add Dashboard at the beginning

        // menuItems.splice(0, 0, home);
        let dashboard = menuItems.findIndex((m) => m.title === "Dashboard");
        let assets = menuItems.findIndex((m) => m.title === "Assets");
        if (dashboard !== -1) {
          const obj = menuItems.splice(dashboard, 1)[0];
          menuItems.splice(0, 0, obj);
        }
        let oilEvent = menuItems.findIndex((m) => m.title === "Open Item's List (OIL)");
        if (oilEvent !== -1 && dashboard !== -1) {
          const event = menuItems.splice(oilEvent, 1)[0];
          menuItems.splice(1, 0, event);
        }else{
          const event = menuItems.splice(oilEvent, 1)[0];
          menuItems.splice(0, 0, event);
        }

        // Add airworthinessTasks after Dashboard
        let maintenanceTaskList = modules
          .filter((m2) => m2.parentPage === 'statuslist' && m2.moduleName !== 'Repair Damage List')
          .map((m2) => ({
            title: m2.moduleName,
            url: m2.url,
            iconName: this.getModuleIcon(m2),
            moduleId: this.parseModuleId(m2.moduleId),
          }));
        if (maintenanceTaskList?.length > 0) {
          let airworthinessTasks = {
            title: 'Maintenance Tasks',
            url: 'airdirectives',
            iconName: 'airplane-outline',
            moduleId: 'air-task-12',
            disable: true,
            children: modules
              .filter((m2) => m2.parentPage === 'statuslist' && m2.moduleName !== 'Repair Damage List')
              .map((m2) => ({
                title: m2.moduleName,
                url: m2.url,
                iconName: this.getModuleIcon(m2),
                moduleId: this.parseModuleId(m2.moduleId),
              })),
          };
          if(oilEvent !== -1 && dashboard !== -1 && assets !== -1){
            menuItems.splice(4, 0, airworthinessTasks);
          }else if(dashboard !== -1 && assets !== -1 || oilEvent !== -1 && assets !== -1 || oilEvent !== -1 && dashboard !== -1){
            menuItems.splice(3, 0, airworthinessTasks);
          }else if(dashboard !== -1){
            menuItems.splice(1, 0, airworthinessTasks);
          }else{
            menuItems.splice(0, 0, airworthinessTasks);
          }

        }

        // Move Settings to the end
        const settingsIndex = menuItems.findIndex((m) => m.title === 'Settings');
        if (settingsIndex !== -1) {
          const settings = menuItems.splice(settingsIndex, 1)[0];
          menuItems.push(settings);
        }
        return (
          menuItems
            // .filter(m => m.title !== 'Air Maintenance Tasks')
            .filter((m) => m.title !== 'Airworthiness Directives')
            .filter((m) => m.title.toLowerCase() !== 'clients')
            .filter((m) => m.title.toLowerCase() !== 'reports')
            .filter((m) => m.title.toLowerCase() !== 'status list')
        );
      }),
      catchError((error) => {
        this.loadPage = true;
        if (error?.error?.error === 'Expired token' || error?.error?.error === 'Invalid signature') {
          localStorage.removeItem('user');
          localStorage.setItem('userFullName', '');
          localStorage.setItem('userName', '');
          localStorage.setItem('0', '');
          localStorage.removeItem('token');
          // localStorage.removeItem("refresh");
          localStorage.removeItem('last_activity');
          localStorage.removeItem('subSelectedTab');
          localStorage.removeItem('assetsActiveTab');
          localStorage.removeItem('activeMenuIndex');
          sessionStorage.clear();
          this.appService?.triggerRemoveMenu();
          window.location.href = '/#/auth';
        }
        console.error('Error getting menu items', error);
        return throwError(error);
      }),
    );
  }
  toggleMenu(index: number) {
    this.activeMenuIndex = this.activeMenuIndex === index ? null : index;
    localStorage.setItem('activeMenuIndex', JSON.stringify(this.activeMenuIndex));
  }
  restoreMenuState() {
    const storedIndex = localStorage.getItem('activeMenuIndex');
    if (storedIndex !== null) {
      this.activeMenuIndex = JSON.parse(storedIndex);
    }

    // Check if the current route is in a submenu and expand its parent
    const currentRoute = this.router?.url;
    this.menuItems$.subscribe((items) => {
      const currentRoute = this.router.url;
      items.forEach((menu, index) => {
        if (menu.children?.some((sub) => sub.url === currentRoute)) {
          this.activeMenuIndex = index;
          localStorage.setItem('activeMenuIndex', JSON.stringify(index));
        }
      });
    });
  }

  private parseModuleId(moduleId: string | number): string {
    return typeof moduleId === 'string' ? moduleId : moduleId.toString();
  }

  private getModuleIcon(module: Module) {
    const overrideIcon = modules.get(this.parseModuleId(module.id))?.iconName;
    if (overrideIcon) {
      return overrideIcon;
    }
    return module.iconName;
  }
}

const moduleNameToPageNameMap = new Map([
  ['home', 'home'],
  ['Settings', 'settings'],
]);

const modules = new Map([
  ['0', { moduleName: 'Home', url: '/home', iconName: 'home-outline' }],
  ['10', { moduleName: 'Settings', url: '/settings', iconName: 'settings-outline' }],
  ['11', { moduleName: 'Users', url: '/settings/users', iconName: 'people-outline' }],
  ['12', { moduleName: 'Document Types', url: '/settings/documenttypes', iconName: 'document-text-outline' }],
  ['13', { moduleName: 'Reports', url: '/reports', iconName: 'documents-outline' }],
  ['14', { moduleName: 'Status List', url: '/statuslist', iconName: 'list-outline' }],
  // ["15", { moduleName: "Airworthiness Directives", url: "/airdirectives", iconName: "airplane-outline" }],
  ['16', { moduleName: 'Assets', url: '/assets', iconName: 'build-outline' }],
  ['17', { moduleName: 'Clients', url: '/clients', iconName: 'business-outline' }],
  ['18', { moduleName: 'Roles', url: '/settings/roles', iconName: 'key-outline' }],
  ['19', { moduleName: 'Logs', url: '/logs', iconName: 'book-outline' }],
  ['21', { moduleName: 'MPD', url: '/mpd', iconName: 'document' }],
  ['22', { moduleName: 'Repair Damage', url: '/repairdemage', iconName: 'document' }],
  ['20', { moduleName: 'Airworthiness Directives', url: '/airdirectives', iconName: 'document' }],
]);
